import React, {useState} from 'react';
import '../../style/animate-wave.css'
import DisplayArray from './DisplayArray';

const AnimWave = () => {
    return (
        <div className='anim_wrap_wave'>
            <div className='wave__wrap wrap_1'>
                <div className='abs'>
                    <div className='wave__line'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
             <div className='wave__wrap wrap_2'>
                <div className='abs'>
                    <div className='wave__line line-2'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_4'>
                <div className='abs'>
                    <div className='wave__line line-4'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_5'>
                <div className='abs'>
                    <div className='wave__line line-5'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_6'>
                <div className='abs'>
                    <div className='wave__line line-6'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_7'>
                <div className='abs'>
                    <div className='wave__line line-7'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_8'>
                <div className='abs'>
                    <div className='wave__line line-8'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
           <div className='wave__wrap wrap_9'>
                <div className='abs'>
                    <div className='wave__line line-9'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_10'>
                <div className='abs'>
                    <div className='wave__line line-10'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_11'>
                <div className='abs'>
                    <div className='wave__line line-11'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_12'>
                <div className='abs'>
                    <div className='wave__line line-12'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
             <div className='wave__wrap wrap_13'>
                <div className='abs'>
                    <div className='wave__line line-13'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
           <div className='wave__wrap wrap_14'>
                <div className='abs'>
                    <div className='wave__line line-14'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_15'>
                <div className='abs'>
                    <div className='wave__line line-15'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_16'>
                <div className='abs'>
                    <div className='wave__line line-16'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_17'>
                <div className='abs'>
                    <div className='wave__line line-17'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_18'>
                <div className='abs'>
                    <div className='wave__line line-18'>
                        <DisplayArray/>
                    </div>
                </div>
            </div>
            <div className='wave__wrap wrap_19'>
                <div className='abs'>
                    <div className='wave__line line-19'>
                        <DisplayArray/>
                    </div>
                </div>
            </div> 
            <div className='wave__wrap wrap_20'>
                <div className='abs'>
                    <div className='wave__line line-19'>
                        <DisplayArray/>
                    </div>
                </div>
            </div> 
            <div className='wave__wrap wrap_21'>
                <div className='abs'>
                    <div className='wave__line line-19'>
                        <DisplayArray/>
                    </div>
                </div>
            </div> 
            <div className='wave__wrap wrap_22'>
                <div className='abs'>
                    <div className='wave__line line-19'>
                        <DisplayArray/>
                    </div>
                </div>
            </div> 
            <div className='wave__wrap wrap_23'>
                <div className='abs'>
                    <div className='wave__line line-19'>
                        <DisplayArray/>
                    </div>
                </div>
            </div> 
            <div className='wave__wrap wrap_24'>
                <div className='abs'>
                    <div className='wave__line line-19'>
                        <DisplayArray/>
                    </div>
                </div>
            </div> 
            <div className='wave__wrap wrap_25'>
                <div className='abs'>
                    <div className='wave__line line-19'>
                        <DisplayArray/>
                    </div>
                </div>
            </div> 
        </div>
    );
};

export default AnimWave;